<template>
  <div class="iphone-container">
    <div class="background-image"></div>
    <div class="gradient-overlay"></div>
    <div class="main-content">
      <div class="status-container">
        <div class="status-header">
          <div
              class="status-icon"
              :style="{ backgroundImage: 'url(' + iconUrl + ')' }"
          ></div>
          <div class="status-message">{{ pageTitle }}</div>
          <div v-if="currentApiStatusCode !== 4" class="waiting-text">
            正在等待装货，请稍等...
          </div>
        </div>
        <div class="info-display-container">
          <div class="info-row">
            <span class="info-label">车牌号</span>
            <span class="info-value">{{ carNumber }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">柜号</span>
            <span class="info-value">{{ containerNumber }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">提单号</span>
            <span class="info-value">{{ billNumber }}</span>
          </div>
          <div v-if="driverName" class="info-row">
            <span class="info-label">司机姓名</span>
            <span class="info-value">{{ driverName }}</span>
          </div>
          <div v-if="driverPhone" class="info-row">
            <span class="info-label">司机电话</span>
            <span class="info-value">{{ driverPhone }}</span>
          </div>
          <div v-if="currentApiStatusCode !== 4" class="info-row">
            <span class="info-label">当前状态</span>
            <span class="info-value status-highlight">{{
                currentApiStatusText
              }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getLoadingInfoById} from '@/api/wx';

export default {
  name: 'StatusPage',
  data() {
    return {
      carNumber: '',
      billNumber: '',
      containerNumber: '',
      driverName: '',
      driverPhone: '',
      currentApiStatusCode: null,
      loadingId: '',
      pollTimer: null,
    };
  },
  computed: {
    pageTitle() {
      const titleMap = {
        0: '排队中',
        1: '等待装货',
        2: '正在装货',
        3: '装货暂停',
        4: '装货完成',
      };
      return titleMap[this.currentApiStatusCode] || '加载中...';
    },
    iconUrl() {
      switch (this.currentApiStatusCode) {
        case 2:
          return require('@/assets/loading.png');
        case 3:
          return require('@/assets/stop.png');
        case 4:
          return require('@/assets/success.png');
        case 0:
        case 1:
        default:
          return require('@/assets/wait.png');
      }
    },
    currentApiStatusText() {
      const statusMap = {
        0: '排队中',
        1: '未装货',
        2: '装货中',
        3: '装货暂停',
        4: '装货完成',
      };
      return statusMap[this.currentApiStatusCode] || '未知状态';
    },
  },
  created() {
    const shipmentDataString = sessionStorage.getItem('latestShipment');
    if (shipmentDataString) {
      const shipmentData = JSON.parse(shipmentDataString);
      this.loadingId = shipmentData.id;
      this.carNumber = shipmentData.licenseNo || 'N/A';
      this.billNumber = shipmentData.billNo || 'N/A';
      this.containerNumber = shipmentData.containerNo || 'N/A';
      this.driverName = shipmentData.driverName || '';
      this.driverPhone = shipmentData.driverPhone || '';
      this.currentApiStatusCode = shipmentData.status;
      if (this.currentApiStatusCode !== 4 && this.loadingId) {
        this.startPolling();
      }
    } else {
      this.$router.replace({name: 'AuthPage'});
    }
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
  methods: {
    startPolling() {
      this.checkLoadingStatus();
      this.pollTimer = setInterval(() => {
        this.checkLoadingStatus();
      }, 30000);
    },
    async checkLoadingStatus() {
      if (!this.loadingId) return;
      try {
        const loadingInfo = await getLoadingInfoById(this.loadingId);
        if (loadingInfo && typeof loadingInfo.status !== 'undefined') {
          this.currentApiStatusCode = loadingInfo.status;
          if (this.currentApiStatusCode === 4) {
            clearInterval(this.pollTimer);
            const updatedData = JSON.parse(
                sessionStorage.getItem('latestShipment')
            );
            if (updatedData) {
              updatedData.status = 4;
              sessionStorage.setItem(
                  'latestShipment',
                  JSON.stringify(updatedData)
              );
            }
          }
        }
      } catch (error) {
        console.error('查询装货状态失败:', error);
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap');

* {
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

.iphone-container {
  width: 100%;
  max-width: 480px;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  background-color: #d6e4ee;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-image: url('@/assets/lera.png');
  background-size: cover;
  background-position: center;
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 40vh;
  left: 0;
  width: 100%;
  height: 70vh;
  background: linear-gradient(
      180deg,
      rgba(0, 54, 90, 1) 20%,
      rgba(199, 219, 233, 1) 45%,
      rgba(214, 228, 238, 1) 100%
  );
  z-index: 1;
}

.main-content {
  position: relative;
  z-index: 2;
  width: 90%;
  margin: 0 auto;
}

.status-container {
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 12px 30px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.status-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.status-icon {
  width: 56px;
  height: 56px;
  background-size: cover;
}

.status-message {
  font-size: 18px;
  font-weight: 500;
  color: #111111;
}

.waiting-text {
  font-size: 14px;
  color: #666;
  margin-top: -12px;
}

.info-display-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-row {
  width: 100%;
  min-height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 8px 0;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 400;
  font-size: 17px;
  color: #25282a;
}

.info-value {
  font-weight: 400;
  font-size: 17px;
  color: #8e8e93;
}

.status-highlight {
  color: #007aff;
  font-weight: 500;
}
</style>